module.exports = __webpack_public_path__ + "img/step3_zh-HK.8188a76e.png";